module.exports = __webpack_public_path__ + "/login_ui/img/vi-f195a506a243ac68d5511c9473dfe609.svg";